export default __webpack_public_path__ + "static/mobile_KV13-87d55842eb122badc2169491ec1bd6d6.mp4";